import { requestJson } from './requestJson';

// Changes a test's mode. Refused with 409 once the test has any reactions —
// switching mid-flight would mix reviewers who saw each other with reviewers who
// did not, and the resulting dashboard would render perfectly and mean nothing.
export async function postTestMode(
  dashboardKey: string,
  mode: 'blind' | 'live'
): Promise<{ mode: 'blind' | 'live' }> {
  return await requestJson(`/api/dashboard/${encodeURIComponent(dashboardKey)}/mode`, {
    method: 'POST',
    body: JSON.stringify({ mode })
  });
}
